import { useState } from "react";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import DynamicDialog from "../Dialog/Dialog";
import Button from "@mui/material/Button";

export const ApprovalButton = ({
  sourceData,
  buttonText,
  getApprovalData,
  isApproval,
  setIsApproval,
  getSources,
  isTableDataLoading,
  any_row_isEditing,
}) => {
  const [open, setOpen] = useState(false);
  const handleClick = () => {
    if (!isApproval) {
      if (!sourceData.is_initial && sourceData.is_table_loading) {
        setOpen(true);
      } else {
        setIsApproval(!isApproval);
        getApprovalData();
      }
    } else {
      setIsApproval(!isApproval);
      getSources();
    }
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleContinue = () => {
    handleCloseModal();
    setIsApproval(!isApproval);
    getApprovalData();
  };
  return (
    <>
      <FormControlLabel
        control={
          <Switch
            checked={isApproval}
            onChange={handleClick}
            disabled={isTableDataLoading || any_row_isEditing}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": {
                color: "#ff4081", // pink thumb
              },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                backgroundColor: "#ff4081", // pink track
              },
            }}
          />
        }
        label={buttonText}
        sx={{
          "& .MuiFormControlLabel-label": {
            fontSize: "15px",
            fontWeight: 500,
            color: "#333", // darker gray
          },
        }}
      />
      <DynamicDialog
        openModal={open}
        hasCustomCancelButton={false}
        closeModel={handleCloseModal}
        title={"Confirmation"}
        content={
          <p
            style={{ fontSize: "16px", color: "black", marginTop: "6px" }}
          >{`Changes made in the table will be deleted. Are you sure, Do you want to continue?`}</p>
        }
        actions={
          <Button
            onClick={handleContinue}
            style={{
              backgroundColor: "#46596A",
              fontFamily: "Hind Siliguri",
              fontSize: "12px",
              fontWeight: "bold",
              marginRight: "5px",
              color: "white",
            }}
          >
            Continue
          </Button>
        }
      />
    </>
  );
};
